import { RouteObject } from 'react-router-dom'

import { authRoutes } from 'routes/Auth'
import DashboardRoutes from 'routes/Dashboard'
import NotFoundPage from 'routes/Dashboard/ui/components/NotFoundPage'

import RedirectByRole from 'modules/Auth/components/RedirtcByRole'

import CustomEmpty from 'shared/ui/CustomEmpty'

const emptyClassname = 'w-full h-full flex items-center justify-center'

export const AppRoutes: RouteObject[] = [
  ...authRoutes,
  {
    path: 'dashboard/*',
    element: <DashboardRoutes />,
  },
  {
    path: '',
    element: <RedirectByRole />,
  },
  {
    path: '500/',
    element: (
      <div className={emptyClassname}>
        <CustomEmpty
          type="someWrong"
          title="Упс... Что-то пошло не так"
          description="Приносим извинения за неудобства, мы усердно работаем над этим"
          btnText="Назад"
          className="max-w-[600px]"
          size="large"
        />
      </div>
    ),
  },
  {
    path: 'not-found',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]
